import { Injectable, Inject } from '@angular/core';
import { Http, URLSearchParams, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from 'base-api-service';
import 'rxjs/add/operator/map';

import { CommonUtil } from 'base-api-service';
import { AuthService } from './auth.service';
import { AuthHelper } from './auth.helper';


export class OAuthService implements AuthService {

  constructor(
    private http: Http,
     private apiConfig: ApiConfig,
    private authHelper: AuthHelper
  ) { }

  getServiceUrl(): string {
    return CommonUtil.getApiUrl('OAUTH_SERVICE_URL', this.apiConfig) || '';
  }

  login(username: string, password: string) {
    const data = 'grant_type=password&username=' + username + '&password=' + password;
    const headers: Headers = new Headers();
    headers.append('Authorization', 'Basic ' + btoa(this.apiConfig.credentials.clientId + ':' + this.apiConfig.credentials.clientSecret));
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const opts = new RequestOptions({ headers: headers });

    const serviceUrl = this.getServiceUrl();

    if (serviceUrl == null) {
      return null;
    }

    return this.http.post(serviceUrl, data, opts).map((res: Response) => {
      const userData = res.json() || {};
      const expiresIn = userData.expires_in || this.apiConfig.timeExpired;

      // add access token when mock environment
      if (this.apiConfig.apiEnv === 'mock') {
        userData.access_token = '12345-67890-5555';
      }

      // login successful if there's a jwt token in the response
      if (userData.access_token) {
        this.authHelper.addUserInfo(username, expiresIn);
        this.authHelper.addTokenInfo(userData.access_token, expiresIn);
      }

      return userData;
    });
  }

  logout() {
    // remove user session info
    this.authHelper.removeUserInfo();
    this.authHelper.removeTokenInfo();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ApiConfig, decorators: [{ type: Inject, args: ['api.config', ] }, ]},
{type: AuthHelper, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
